import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('KIT SERVICE');

@Injectable({
  providedIn: 'root'
})
export class KitService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'kits' como el nombre del recurso a la clase base
    super('kits');
    log.debug('Servicio de Kits inicializado');
  }

}

